import React from 'react';

import TopBar from '@components/general/topBar/TopBar';
import NavToggle from '@components/general/sideBar/NavToggle';

const Header = () => (
  <header className="page-header" role="banner">
    <NavToggle />
    <TopBar />
  </header>
);

export default Header;
